import { dateToStringFormat } from "./dateToStringFormat";
import { FtlRoutingViewModel } from "../../../../../ViewModel/FtlRoutingViewModel";

export const getFormattedETValues = (element: FtlRoutingViewModel) => {
  if (element !== null && element !== undefined) {
    if (element.ETA !== null && element.ETA !== undefined) {
      element.ETA = dateToStringFormat(element.ETA, "HH:mm");
    } else {
      element.ETA = "N/A";
    }

    if (element.ETD !== null && element.ETD !== undefined) {
      element.ETD = dateToStringFormat(element.ETD, "HH:mm");
    } else {
      element.ETD = "N/A";
    }
  }

  return element;
};
